module.exports = __webpack_public_path__ + "img/PROFISSIONAL_DE_SAUDE.d363d29c.svg";